<template>
    <div class="d-flex">
        <template v-if="score">
            <!-- determine the number of gold stars vs. blank stars -->
            <img v-for="i in score"
                 src="https://dz8osaahf9pd7.cloudfront.net/images/assets/newGoldstar.png" alt="gold-star"
                 class="img-fluid float-left" :style="reviewStarStyles">
            <img v-for="i in (5 - score)"
                 src="https://dz8osaahf9pd7.cloudfront.net/images/assets/newBlankstar.png" alt="blank-star"
                 class="img-fluid float-left" :style="reviewStarStyles">
        </template>
        <template v-else>
            <!-- 5 blank stars -->
            <img v-for="i in 5"
                 src="https://dz8osaahf9pd7.cloudfront.net/images/assets/newBlankstar.png" alt="blank-star"
                 class="img-fluid float-left" :style="reviewStarStyles">
        </template>
        <span v-if="showCount" class="pl-1" :style="countStyles">
            <template v-if="count">({{ count }})</template>
            <template v-else>(0)</template>
        </span>
    </div>
</template>

<script>
export default {
    name: "DisplayReview",
    props: {
        score: Number,
        count: Number,
        showCount: {type: Boolean, default: false},
        displayCard: {type: Boolean, default: false},
    },
    data() {
        return {}
    },
    computed: {
        reviewStarStyles: function () {
            return (this.displayCard) ?
                {paddingTop: "0.25rem", paddingBottom: "0.5rem", marginRight: ".1em", width: "1em", height: "1.75rem"} :
                {marginRight: ".1em", height: "1.5em", width: "1.5em"};
        },
        countStyles: function () {
            return (this.displayCard) ? {paddingTop: "0.25rem", fontSize: "80%"} : {paddingTop: "0.15rem"};
        }
    }
}
</script>

<style scoped>
</style>
